export namespace SchedulesAction {
  export class UpdatePrevStyle {
    static readonly type = '[Schedules] Update Previous Style';
    constructor(public prevStyle: string) {}
  }
}
